import { NavLink } from "react-router-dom";
import { ChartBar, Users, MagnifyingGlass, Kanban, Buildings, EnvelopeSimple, ClockCounterClockwise, TrendUp, BookOpen, SignOut, Key } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import { useState } from "react";
import { ChangePasswordDialog } from "./ChangePasswordDialog";

const navItems = [
  { to: "/", label: "Dashboard", icon: ChartBar, testid: "nav-dashboard" },
  { to: "/leads", label: "Leads", icon: Users, testid: "nav-leads" },
  { to: "/clinics", label: "Clinics", icon: Buildings, testid: "nav-clinics" },
  { to: "/finder", label: "Physician Finder", icon: MagnifyingGlass, testid: "nav-finder" },
  { to: "/pipeline", label: "Pipeline", icon: Kanban, testid: "nav-pipeline" },
  { to: "/activities", label: "Activity Log", icon: ClockCounterClockwise, testid: "nav-activities" },
  { to: "/performance", label: "BD Performance", icon: TrendUp, testid: "nav-performance" },
  { to: "/stages", label: "Stage Definitions", icon: BookOpen, testid: "nav-stages" },
  { to: "/templates", label: "Templates", icon: EnvelopeSimple, testid: "nav-templates" },
];

export const Sidebar = () => {
  const { user, signOut } = useAuth();
  const [cpOpen, setCpOpen] = useState(false);
  return (
    <aside className="w-60 bg-white border-r border-[#E2E2E5] flex flex-col h-screen sticky top-0" data-testid="sidebar">
      <div className="p-5 border-b border-[#E2E2E5]">
        <div className="flex items-center gap-3">
          <img
            src="/brand/stryde-mark.jpg"
            alt="Stryde Research"
            className="w-9 h-9 object-contain"
            style={{ filter: "drop-shadow(0 0 0 transparent)" }}
          />
          <div>
            <div className="font-display font-black text-[15px] tracking-tight leading-none">
              <span className="text-[#006CFF]">STRYDE</span>
            </div>
            <div className="text-[10px] font-mono uppercase text-[#5C5E66] tracking-[0.18em] mt-1">Medics</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 mb-1 text-sm font-medium transition-colors border-l-2 ${
                  isActive
                    ? "bg-[#006CFF0F] text-[#006CFF] border-l-[#FF9900]"
                    : "text-[#0A0B0F] hover:bg-[#F0F0F2] border-l-transparent"
                }`
              }
            >
              <Icon size={18} weight="regular" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-3 border-t border-[#E2E2E5]" data-testid="sidebar-user">
        {user && (
          <div className="mb-2 px-2 py-2 bg-[#F7F7F8] border border-[#E2E2E5]">
            <div className="text-[10px] font-mono uppercase tracking-wider text-[#5C5E66]">Signed in</div>
            <div className="text-xs font-medium truncate mt-0.5" title={user.email}>{user.name || user.email.split("@")[0]}</div>
            <div className="text-[10px] font-mono text-[#5C5E66] truncate" title={user.email}>{user.email}</div>
          </div>
        )}
        <button
          onClick={() => setCpOpen(true)}
          data-testid="change-password-btn"
          className="w-full flex items-center justify-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-wider text-[#5C5E66] hover:bg-[#F0F0F2] hover:text-[#006CFF] border border-[#E2E2E5] mb-1"
        >
          <Key size={14} /> Change Password
        </button>
        <button
          onClick={signOut}
          data-testid="sign-out-btn"
          className="w-full flex items-center justify-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-wider text-[#5C5E66] hover:bg-[#F0F0F2] hover:text-[#C62828] border border-[#E2E2E5]"
        >
          <SignOut size={14} /> Sign Out
        </button>
        <div className="text-[10px] font-mono uppercase text-[#5C5E66] tracking-wider mt-3">v1.0 · MVP</div>
        <div className="text-xs text-[#5C5E66] mt-0.5">Clinical Research SMO</div>
        <ChangePasswordDialog open={cpOpen} onOpenChange={setCpOpen} mustChange={false} />
      </div>
    </aside>
  );
};
